import { PageFilter } from './page-filter';

export class EventLogFilter extends PageFilter {
    pagesize?: number;
    from?: Date;
    to?: Date;
}
